export default function getMarkettingOptInStatus(oneIdData = {}) {
    const { marketing = [], token: { swid, access_token: accessToken } = {} } = oneIdData;
    if (marketing.length) {
        const ePlusMarketingOptIns = marketing.filter(opt =>
                opt.code === 'ESPN+_L' && opt.status !== 'declined' && opt.status !== 'accepted'
            );
        if (swid && accessToken && ePlusMarketingOptIns.length) {
            return {
                swid,
                accessToken,
                shouldUpdateOptIns: true
            };
        }
    }
    return { shouldUpdateOptIns: false };
}



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/util/getMarkettingOptInStatus.js